import { ParticipantView } from '@seen/core/models/participantView'
import { useCallback } from 'react'
import type { Filter } from '#src/components/filter/Filter.tsx'
import { ViewComposerDialogContent } from '#src/components/ViewComposerDialogContent.tsx'
import { useAddRecentSelection } from '#src/hooks/useAddRecentSelection.ts'
import { useCreateMutation } from '#src/hooks/useCreateMutation.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import {
  type ParticipantViewDisplay,
  useParticipantsPageStore,
} from '#src/pages/participants/useParticipantsPageStore.ts'

export function ParticipantViewComposerDialogContent({
  filters,
  display,
  onCreate,
}: {
  filters: Filter[]
  display: Partial<ParticipantViewDisplay> | undefined
  onCreate: (view: ParticipantView) => any
}): React.ReactNode {
  const createMutation = useCreateMutation<ParticipantView>()
  const setSelectedView = useParticipantsPageStore((state) => state.setView)
  const currentPractitioner = useCurrentPractitioner()
  const addRecentSelection = useAddRecentSelection()

  const handleSuccess = useCallback(
    (view: ParticipantView) => {
      setSelectedView(view.referenceString)
      void addRecentSelection(view.referenceString)
      onCreate(view)
    },
    [onCreate, setSelectedView, addRecentSelection]
  )

  return (
    <ViewComposerDialogContent
      isSubmitting={createMutation.isPending}
      onSubmit={(values) =>
        createMutation.mutate(
          new ParticipantView({
            name: values.name,
            owner: currentPractitioner.reference,
            filters: JSON.stringify(filters),
            display: JSON.stringify(display),
            access: values.access,
          }),
          {
            onSuccess: handleSuccess,
          }
        )
      }
    />
  )
}
